import {AxiosError} from 'axios';
import axiosClient from '../axiosClient';
import {POST_COORDINATOR_REQUEST_LISTING_URL} from '../../constants/apiUrls';
import {useCustomMutation} from '../utils/useCustomMutation';
import {ApiPathParam} from '../../models/SearchParamSchema';
import {PaginatedData} from '../../models/List';
import {GenericErrorResponse} from "../typings";

// =============================================================================
// Request & Response Model
// =============================================================================

export interface PostCoordinatorRequestData {
  apiPathParam: ApiPathParam;
  search: string;
}

export interface PostCoordinatorResponseData {
  accessArrangementWindowOpened: boolean;
  noExamRegistered: boolean;
  accessArrangementPage: PaginatedData<CoordinatorAccessArrangementListing>;
}

export interface CoordinatorAccessArrangementListing {
  uuid: string;
  applicationDateTime: string;
  examLevels: string;
  nricFin: string;
  candidateName: string;
  requestStatus: string;
  accessArrangementOpen: boolean;
}

// =============================================================================
// Mutation
// =============================================================================
interface Input {
  onSuccess?: (data: PostCoordinatorResponseData) => void;
  onError?: (error: AxiosError<GenericErrorResponse>) => void;
}

export const usePostCoordinatorCandidateListing = ({onSuccess, onError}: Input = {}) => {
  const postCoordinatorRequestListing = async (payload: PostCoordinatorRequestData) => {
    const res = await axiosClient.post<PostCoordinatorResponseData>(
        POST_COORDINATOR_REQUEST_LISTING_URL(payload.apiPathParam),
        {
          search: payload.search,
        }
    );
    return res.data;
  };

  return useCustomMutation(postCoordinatorRequestListing, {
    onSuccess,
    onError,
  });
};
